import axios from "axios";

const instance = axios.create({
    // baseURL: process.env.REACT_APP_BASE_URL
    baseURL:  process.env.REACT_APP_BASE_URL
    // baseURL: 'https://app.getdex.ai/api'
});

export default instance;